/* Antigos: personalizzazioni sopra al tema Emporium */
(function () {
  // Mobile: il bottone hamburger in alto a sinistra apre il menu del tema
  // (il toggle originale resta in fondo alla pagina e fa da "Chiudi" a menu aperto).
  // Il bottone porta anche data-dialog-button-toggle: ce-dialog lo guarda per capire
  // dove intrappolare il focus. Senza, lo intrappola nel solo pannello: il focus finisce
  // nella ricerca (che nasconde le voci del menu) e la barra "Chiudi" resta fuori.
  document.addEventListener('click', function (event) {
    const button = event.target.closest('[data-antigos-menu-open]');
    if (!button) return;

    const toggle = document.querySelector('summary[aria-controls="header__mobile-navigation"]');
    if (toggle) toggle.click();
  });

  document.addEventListener('ce-dialog:is-open', function (event) {
    const dialog = event.target;
    if (!dialog.querySelector || !dialog.querySelector('#header__mobile-navigation')) return;

    for (const button of document.querySelectorAll('[data-antigos-menu-open]')) {
      button.setAttribute('aria-expanded', event.detail ? 'true' : 'false');
    }
  }, true);

  // Barra spedizione gratuita (app Essential Free Shipping): resta visibile 3 secondi
  // ogni volta che compare o cambia testo (es. dopo un add to cart), poi sparisce.
  const BAR = '.essential_free_shipping_bar_wrapper';
  let barFadeTimer = null;
  let barHideTimer = null;

  function showBarBriefly() {
    const bar = document.querySelector(BAR);
    if (!bar) return;

    clearTimeout(barFadeTimer);
    clearTimeout(barHideTimer);
    bar.classList.remove('antigos-fsb-out', 'antigos-fsb-gone');

    barFadeTimer = setTimeout(function () {
      bar.classList.add('antigos-fsb-out');
      barHideTimer = setTimeout(function () {
        bar.classList.add('antigos-fsb-gone');
      }, 300);
    }, 3000);
  }

  // Cart drawer: l'app EZ Terms inserisce la spunta accanto ai bottoni (e la reinserisce
  // a ogni aggiornamento del carrello): la si sposta nella riga sotto al totale.
  function placeCartTerms() {
    for (const slot of document.querySelectorAll('[data-antigos-terms-slot]')) {
      const actions = slot.closest('.antigos-cart-actions');
      const terms = actions && actions.querySelector('.terms-relentless');
      if (terms && terms.parentElement !== slot) slot.appendChild(terms);
    }
  }

  new MutationObserver(function (mutations) {
    placeCartTerms();

    for (const mutation of mutations) {
      const target = mutation.target.nodeType === 1 ? mutation.target : mutation.target.parentElement;
      if (target && target.closest(BAR)) return showBarBriefly();

      for (const node of mutation.addedNodes) {
        if (node.nodeType === 1 && (node.matches(BAR) || node.querySelector(BAR))) return showBarBriefly();
      }
    }
  }).observe(document.documentElement, { childList: true, subtree: true, characterData: true });

  document.addEventListener('DOMContentLoaded', showBarBriefly);
  document.addEventListener('DOMContentLoaded', placeCartTerms);

  // Add to cart: apre il carrello laterale invece di lasciare solo il toast.
  document.addEventListener('Themu:cart:add', function () {
    const drawer = document.querySelector('ce-cart-drawer');
    if (!drawer || drawer.getAttribute('is-open') === 'true') return;
    if (typeof drawer.handleClickButtonOpen !== 'function') return;

    // un giro dopo, così ce-cart ha già riscritto il contenuto del drawer
    setTimeout(function () {
      if (drawer.getAttribute('is-open') !== 'true') drawer.handleClickButtonOpen();
    }, 0);
  });
})();
